import {tva} from "@gluestack-ui/nativewind-utils/tva";
import type {GroupBase, OptionProps} from "react-select";
import {components} from "react-select";

import {Box} from "../ui/box";
import {HStack} from "../ui/hstack/index.web";
import {Text} from "../ui/text";

import type {OptionType} from "./Select";

const wrapperStyle = tva({
    base: "items-center opacity-100",
    variants: {
        disabled: {
            true: "opacity-50"
        }
    }
});

export function Option<
    Option extends OptionType,
    IsMulti extends boolean,
    Group extends GroupBase<Option>
>({children, ...props}: OptionProps<Option, IsMulti, Group>) {
    const {
        data: {Icon, leftIcon},
        isDisabled
    } = props;

    return (
        <components.Option {...props}>
            <HStack className={wrapperStyle({disabled: isDisabled})} space="xs">
                {leftIcon}
                <Text isTruncated variant="xs">
                    {children}
                </Text>
                <Box className="shrink-0 grow-0">{Icon}</Box>
            </HStack>
        </components.Option>
    );
}
